import { collection, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../../../firebase";
import AllUserMessage from "./AllUserMessage";
import { useSelector } from "react-redux";
import { SelectChatUser } from "../../../../store/chatUserSlice";
import { SelectUser } from "../../../../store/usersSlice";

function AllUserMessages({ users, reloadMessages }) {
  const [messages, setMessages] = useState([]);
  const currentUser = useSelector(SelectUser);
  console.log("compnay", currentUser?.companyName);
 
  useEffect(() => {
    const getAllUserChats = async () => {
      const chatsRef = collection(
        db,
        "companies",
        currentUser?.companyName,
        "allUserChats"
      );
      try {
        const snapshort = await getDocs(chatsRef);
        const fetchedData = snapshort.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("fetched all data", snapshort);
  
        setMessages(fetchedData);
      } catch (err) {
        console.log("error while fecthing data", err);
      }
    };
    getAllUserChats();
  },[reloadMessages]);

  console.log("all user chats", messages);

  const sortedMessages = messages.sort((a, b) => {
    const dateA = new Date(a.date.seconds * 1000 + a.date.nanoseconds / 1e6);
    const dateB = new Date(b.date.seconds * 1000 + b.date.nanoseconds / 1e6);
    return dateA - dateB;
});

  return (
    <div
      className="chat-content"
      style={{
        borderRight: "1px solid silver",
      }}
    >
      {sortedMessages?.length > 0 &&
        sortedMessages?.map((m) => (
          <AllUserMessage message={m} key={m.id} users={users} />
        ))}
    </div>
  );
}

export default AllUserMessages;
